import { Formik, Form } from "formik";
import React from "react";
import EditorTextArea from "./EditorTextArea";
import { RxCross1 } from "react-icons/rx";
import FormikErrorMessage from "./FormikErrorMessage";
import FormikField from "./FormikField";
import PrimaryButton from "./PrimaryButton";

type Props = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const ConsultForm = ({ setIsOpen }: Props) => {
  return (
    <div className="flex justify-center flex-col max-w-screen-lg w-full p-10  relative z-[1000] bg-white">
      <div className="flex justify-between">
        <div>
          <h1 className="text-2xl sm:text-5xl">
            Book
            <span className="text-2xl sm:text-5xl italic text-primary ml-2 font-eiko-thin">
              a Consultation
            </span>
          </h1>
          <p className="opacity-50 mt-2">
            Get a consultation from our best consultant.
          </p>
        </div>

        <RxCross1
          onClick={() => setIsOpen(false)}
          className="text-4xl cursor-pointer"
        />
      </div>
      <Formik
        initialValues={{
          firstName: "",
          lastName: "",
          phoneNumber: "",
          email: "",
          query: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          console.log(values);
          setSubmitting(false);
          alert(`Thank you for subscribing, ${values.firstName}`);
        }}
      >
        {({ isSubmitting }) => (
          <Form className="flex flex-col justify-center w-full mt-6">
            <div className="mb-8 w-full lg:grid lg:grid-cols-2 gap-4">
              <div className="w-full">
                <FormikField
                  name="firstName"
                  label="First Name"
                  placeholder="First Name"
                />
                <FormikErrorMessage name="firstName" />
              </div>

              <div className="w-full">
                <FormikField
                  type="text"
                  name="lastName"
                  id="lastName"
                  placeholder="Enter Your Last Name"
                  label="Last Name"
                  required
                />
                <FormikErrorMessage name="lastName" />
              </div>
              <div className="w-full">
                <FormikField
                  type="text"
                  name="email"
                  required
                  id="email"
                  placeholder="email@example.com"
                  label="Email"
                />
                <FormikErrorMessage name="email" />
              </div>
              <div className="w-full">
                <FormikField
                  type="text"
                  name="phoneNumber"
                  required
                  id="phoneNumber"
                  placeholder="Enter Your Phone Number"
                  label="Phone Number"
                />
                <FormikErrorMessage name="phoneNumber" />
              </div>
              <div className="col-span-2">
                <EditorTextArea
                  placeholder="Hello there!"
                  name="query"
                  required
                  row={1}
                  label="Message"
                />
                <FormikErrorMessage name="query" />
              </div>
            </div>
            <PrimaryButton
              type="submit"
              disabled={isSubmitting}
              className="bg-primary text-white justify-center max-w-[250px]"
            >
              Send Message
            </PrimaryButton>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ConsultForm;
